import { FB_NAMESPACE } from './constants';
export const formInitialState = {
    [FB_NAMESPACE]: {
        accessToken: '',
        loadingSdk: false,
        fetchingToken: false,
        passwordResetEmail: '',
        errors: {
            isExistingEmail: false,
            authorizationFailedOrInvalidEmail: false,
        },
    },
};
//# sourceMappingURL=state.js.map